<template>
  <div class="cloud-boltGrouting">
    <div class="cloud-boltGrouting-t">
      <div class="cloud-boltGrouting-title" style="width: 100%">
        <div class="cloud-boltGrouting-title-title">
          <img
            src="@/assets/images/groupTitlec.png"
            alt=""
            style="width: 100%; height: 4vh"
          />
          <p>锚注一体机状态监测</p>
          <dv-decoration-3
            class="decoration-container"
            :style="{ width: '3%', height: '30px' }"
            style="position: absolute; top: 1px; margin-left: 96%"
          >
            <!-- 插槽中添加多个小方块 -->
            <div slot="content" class="squares-container">
              <div class="square s1"></div>
              <div class="square s2"></div>
              <div class="square s3"></div>
              <div class="square s4"></div>
              <div class="square s5"></div>
              <div class="square s6"></div>
            </div>
          </dv-decoration-3>
        </div>
      </div>
    </div>

    <div class="cloud-boltGrouting-l">
      <div class="cloud-boltGrouting-content-top">
        <div class="cloud-boltGrouting-content-top-title">
          <img src="@/assets/images/tcar.png" alt="" />
          <p>台车工作状态</p>
        </div>

        <div class="cloud-boltGrouting-content-top-content">
          <div style="margin-left: 5%; cursor: pointer" @click="stateClick">
            <div>
              <img
                src="@/assets/images/stop.png"
                alt=""
                v-if="stateFag === true"
              />
              <p v-if="stateFag === true">停止</p>
              <p
                style="
                  width: 15px;
                  height: 15px;
                  background: #1bffb1;
                  border-radius: 50%;
                  margin-top: 47px;
                  margin-left: 50px;
                "
                v-if="stateFag === false"
              ></p>
              <p v-if="stateFag === false" style="color: #1bffb1">启动</p>
            </div>
            <div>工作状态</div>
          </div>
          <div>
            <div>
              <img src="@/assets/images/start.png" alt="" />
              <p style="color: #1bffb1">正常</p>
            </div>
            <div>采集器通讯状态</div>
          </div>
        </div>

        <div class="cloud-boltGrouting-content-top-content-item">
          <p>隧道名称</p>
          <p>铁路2标隧道</p>
        </div>
        <div class="cloud-boltGrouting-content-top-content-item">
          <p>当前工作里程</p>
          <p>-</p>
        </div>
        <div class="cloud-boltGrouting-content-top-content-item">
          <p>隧道总里程</p>
          <p>DK42+100</p>
        </div>
      </div>

      <div class="cloud-boltGrouting-content-top-content-list">
        <ul>
          <li :class="{ active: itemActive == 0 }" @click="itemActive = 0">
            凿岩
          </li>
          <li :class="{ active: itemActive == 1 }" @click="itemActive = 1">
            锚杆
          </li>
          <li :class="{ active: itemActive == 2 }" @click="itemActive = 2">
            注浆
          </li>
        </ul>
        <div class="cloud-boltGrouting-content-top-content-list-item">
          <img src="@/assets/images/image_null.png" alt="" />
        </div>
      </div>
    </div>

    <div class="cloud-boltGrouting-r">
      <img src="@/assets/images/boltGrouting.png" alt="" />
      <div
        class="cloud-boltGrouting-r-content"
        style="top: 9vh; left: 9.5vw; width: calc(204 / 1920 * 100vw)"
      >
        <div>
          <div>
            <p
              style="
                width: 15px;
                height: 15px;
                background: #1bffb1;
                border-radius: 50%;
                margin-top: 10px;
                margin-left: 10px;
                float: left;
              "
            ></p>
            <span style="line-height: 35px; margin-left: 10px">锚杆系统</span>
          </div>
        </div>
        <div style="background: rgba(0, 0, 0, 0.4)">
          <p style="flex: none; width: 60%;">钻孔深度 <span>(m)</span></p>
          <p>20.0</p>
        </div>
        <div style="background: rgba(0, 0, 0, 0.4)">
          <p style="flex: none; width: 60%;">入孔深度<span>(m)</span></p>
          <p>20.0</p>
        </div>
      </div>

      <div
        class="cloud-boltGrouting-r-content"
        style="top: 20vh; left: 32vw; width: calc(204 / 1920 * 100vw)"
      >
        <div>
          <div>
            <p
              style="
                width: 15px;
                height: 15px;
                background: #1bffb1;
                border-radius: 50%;
                margin-top: 10px;
                margin-left: 10px;
                float: left;
              "
            ></p>
            <span style="line-height: 35px; margin-left: 10px">注浆系统</span>
          </div>
        </div>
        <div style="background: rgba(0, 0, 0, 0.4)">
          <p style="flex: none; width: 60%;">注浆压力<span>(mpa)</span></p>
          <p>20.0</p>
        </div>
        <div style="background: rgba(0, 0, 0, 0.4)">
          <p style="flex: none; width: 60%;">注浆流量<span>(L/min)</span></p>
          <p>20.0</p>
        </div>
      </div>

      <div
        class="cloud-boltGrouting-r-content"
        style="top: 16vh; left: 46.3vw; width: calc(408 / 1920 * 100vw)"
      >
        <div>
          <div>
            <p
              style="
                width: 15px;
                height: 15px;
                background: #1bffb1;
                border-radius: 50%;
                margin-top: 10px;
                margin-left: 10px;
                float: left;
              "
            ></p>
            <span style="line-height: 35px; margin-left: 10px">辅助参数</span>
          </div>
        </div>
        <div style="background: rgba(0, 0, 0, 0.4)">
          <p style="flex: none; width: 30%;">气路压力<span>(bar)</span></p>
          <p>20.0</p>
          <p style="flex: none; width: 30%;">脉冲泵压力<span>(bar)</span></p>
          <p>20.0</p>
        </div>
      </div>

      <div
        class="cloud-boltGrouting-r-content"
        style="top: 60vh; left: 4vw; width: calc(560 / 1920 * 100vw)"
      >
        <div>
          <div>
            <p
              style="
                width: 15px;
                height: 15px;
                background: #1bffb1;
                border-radius: 50%;
                margin-top: 10px;
                margin-left: 10px;
                float: left;
              "
            ></p>
            <span style="line-height: 35px; margin-left: 10px">凿岩系统</span>
          </div>
        </div>
        <div style="background: rgba(0, 0, 0, 0.4)">
          <p>冲击压力<span>(bar)</span></p>
          <p>20.0</p>
          <p>推进压力<span>(bar)</span></p>
          <p>20.0</p>
          <p>回转压力<span>(bar)</span></p>
          <p>20.0</p>
        </div>
        <div style="background: rgba(0, 0, 0, 0.4)">
          <p>钻孔深度<span>(m)</span></p>
          <p>20.0</p>
          <p>钻孔设定深度<span>(m)</span></p>
          <p>20.0</p>
          <p></p>
          <p></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// 引入路由实例
export default {
  name: "boltGrouting",
  components: {},
  data() {
    return {
      itemActive: 0,
      stateFag: true,
    };
  },
  computed: {},
  mounted() {},
  methods: {
    stateClick() {
      this.stateFag = !this.stateFag;
    },
  },
  beforeDestroy() {},
};
</script>
<style scoped>
/* 引入字体 */
@font-face {
  font-family: "DS-Digital";
  src: url("../font/DS-DIGIB.TTF") format("truetype");
  font-weight: normal;
  font-style: normal;
}

.cloud-boltGrouting {
  width: 100%;
  height: 100%;
  text-align: left;

  > .cloud-boltGrouting-t {
    position: relative;
    width: calc(1880 / 1920 * 100vw);
    height: calc(50 / 1080 * 100vh);
    top: 1vh;
    margin-left: 1vw;
    float: left;
    overflow: hidden;
    border-radius: 5px;
  }

  .cloud-boltGrouting-title {
    position: absolute;
    top: 1vh;
    left: 0;
    width: 100%;
    height: calc(43 / 1080 * 100vh);
    background: rgba(0, 0, 0, 0.4);
    border-radius: 10px;

    .cloud-boltGrouting-title-title {
      position: relative;
      top: 0px;
      left: 0px;
      width: 100%;
      height: 2.5vh;
      margin: 0;
      padding: 0;

      img {
        width: 100%;
        height: auto;
        margin: 0;
        padding: 0;
      }

      p {
        position: absolute;
        top: 0.3vh;
        left: 3.01vh;
        width: 100%;
        height: 2.5vh;
        margin: 0;
        padding: 0;
        font-size: 1rem;
        color: #fff;
        text-align: left;
      }
    }
  }

  .cloud-boltGrouting-l {
    position: relative;
    width: calc(360 / 1920 * 100vw);
    height: calc(920 / 1080 * 100vh);
    top: 2vh;
    margin-left: 1vw;
    float: left;
    overflow: hidden;

    > .cloud-boltGrouting-content-top {
      width: 99%;
      height: calc(400 / 1080 * 100vh);
      background: rgba(0, 0, 0, 0.4);

      > .cloud-boltGrouting-content-top-title {
        width: 100%;
        height: calc(35 / 1080 * 100vh);
        background: #033da1 !important;
        border-radius: 0px 0px 0px 0px;

        > img {
          width: 2.5vh;
          height: auto;
          margin: 0;
          padding: 0;
          margin-top: 0.3vh;
          margin-left: 0.5vw;
          float: left;
        }

        > p {
          width: calc(100 / 1920 * 100vw);
          font-size: 0.8rem;
          color: #fff;
          text-align: left;
          float: left;
          margin: 0px;
          margin-left: 0.3vw;
          margin-top: 0.35vh;
        }
      }

      > .cloud-boltGrouting-content-top-content {
        width: 100%;
        height: calc(156 / 1080 * 100vh);
        margin-top: 1.5vh;
        font-size: 0.8rem;

        > div {
          width: calc(158 / 1920 * 100vw);
          height: calc(156 / 1080 * 100vh);
          float: left;
          margin: 1%;
          background: linear-gradient(
            147deg,
            rgba(2, 58, 158, 0.8) 0%,
            rgba(2, 58, 158, 0.3) 100%
          );
          border-radius: 4px 4px 4px 4px;

          > div:nth-child(1) {
            width: 100%;
            height: calc(110 / 1080 * 100vh);
            text-align: center;

            > img {
              width: 18px;
              height: auto;
              margin: 0;
              padding: 0;
              margin-top: 5vh;
              margin-left: 2.5vw;
              float: left;
            }

            > p {
              font-size: 1rem;
              color: #a53636;
              text-align: center;
              margin: 0px;
              margin-top: 4.5vh;
              width: 40px;
              float: left;
            }
          }

          > div:nth-child(2) {
            width: 100%;
            text-align: center;
            color: #929292;
          }
        }
      }

      > .cloud-boltGrouting-content-top-content-item {
        width: 90%;
        height: calc(36 / 1080 * 100vh);
        float: left;
        margin: 5%;
        margin-top: 3%;
        margin-bottom: 0%;
        border-bottom: 1px solid rgba(255, 255, 255, 0.1);

        > p {
          width: 45%;
          height: calc(36 / 1080 * 100vh);
          font-size: 0.7rem;
          margin: 0px;
          padding: 5px;
          text-align: left;
          float: left;
        }

        > p:nth-child(1) {
          font-family: PingFang SC, PingFang SC;
          font-weight: 400;
          color: rgba(255, 255, 255, 0.6);
          text-align: left;
          font-style: normal;
          text-transform: none;
        }

        > p:nth-child(2) {
          font-family: PingFang SC, PingFang SC;
          font-weight: 400;
          color: #fff;
          text-align: right;
          font-style: normal;
          text-transform: none;
        }
      }
    }

    > .cloud-boltGrouting-content-top-content-list {
      width: 100%;
      height: calc(450 / 1080 * 100vh);
      float: left;
      margin: 0px;
      margin-top: 3%;

      > ul {
        width: 100%;
        height: calc(70 / 1080 * 100vh);
        margin: 0px;
        padding: 0px;
        margin-top: -2%;
        list-style: none;

        > li {
          width: 31.7%;
          height: calc(45 / 1080 * 100vh);
          float: left;
          margin: 0px;
          margin-top: 3%;
          margin-bottom: 0%;
          margin-right: 1%;
          text-align: center;
          font-size: 0.8rem;
          line-height: calc(45 / 1080 * 100vh);
          border: 1px solid rgba(255, 255, 255, 0.1);
          background: linear-gradient(
            147deg,
            rgba(2, 58, 158, 0.2) 0%,
            rgba(2, 58, 158, 0.1) 100%
          );
          border-radius: 4px 10px 4px 4px;

          &.active {
            background: linear-gradient(
              147deg,
              rgba(2, 58, 158, 1.8) 0%,
              rgba(2, 58, 158, 0.3) 100%
            );
          }
        }
      }

      > .cloud-boltGrouting-content-top-content-list-item {
        width: 100%;
        height: calc(400 / 1080 * 100vh);
        margin: 0px;
        margin-top: -2%;
        background: linear-gradient(
          147deg,
          rgba(2, 58, 158, 0.3) 0%,
          rgba(2, 58, 158, 0.2) 100%
        );

        > img {
          width: 60%;
          height: auto;
          margin-top: 5vh;
          margin-left: 20%;
        }
      }
    }
  }

  .cloud-boltGrouting-r {
    position: relative;
    width: calc(1510 / 1920 * 100vw);
    height: calc(870 / 1080 * 100vh);
    top: 2vh;
    margin-left: 0.5vw;
    float: left;
    overflow: hidden;
    border-radius: 20px;
    background: rgba(0, 0, 0, 0.4);

    > img {
      width: calc(1010 / 1920 * 100vw);
      height: auto;
      margin-top: 10vh;
      margin-left: 15%;
    }

    > .cloud-boltGrouting-r-content {
      position: absolute;
      width: calc(410 / 1920 * 100vw); /* 根据原设定调整 */
      height: auto; /* 调整为auto以适应内容的高度 */

      > div {
        display: flex;
        flex-wrap: nowrap; /* 防止子元素换行 */
        justify-content: space-between; /* 子元素间分配空间 */
        align-items: center; /* 垂直居中对齐 */
        padding: 0px; /* 可选：增加一些内边距 */
        margin: 0px;

        > p {
          height: calc(26 / 1080 * 100vh);
          flex: 1; /* 让每个p标签都能获得相等的空间 */
          min-width: 0; /* 允许p标签内的文本换行 */
          font-size: 0.8rem;
          line-height: normal; /* 使用正常的行高 */
          text-align: center;
          border: 1px solid rgba(255, 255, 255, 0.1);
          overflow: hidden; /* 隐藏溢出的内容 */
          white-space: nowrap; /* 防止文本换行 */
          text-overflow: ellipsis; /* 当文本溢出时显示省略号 */
          margin: 0px;
          padding: 3px 10px;
          span {
            color: #145ce2;
          }
        }

        
        > p:nth-child(1),
        > p:nth-child(3),
        > p:nth-child(5) {
          flex: none; /* 禁用伸缩，尊重 width */
          width: 20%; /* 现在 width 才会生效 */
        }
      }

      > div:nth-child(1) {
        width: 100%;
        height: calc(30 / 1080 * 100vh);
        line-height: calc(30 / 1080 * 100vh);
        font-size: 0.8rem;
        background: linear-gradient(
          90deg,
          rgba(0, 87, 242, 0.8) 0%,
          rgba(0, 87, 242, 0.24) 100%
        );
        border-radius: 0px 0px 0px 0px;

        > p {
          width: calc(6 / 1920 * 100vw);
          height: calc(8 / 1080 * 100vh);
          background: #09f530;
          border-radius: 50%;
          margin: 0px;
          padding: 0px;
          margin: 0.4vw 0.2vw;
        }
      }
    }
  }
}
</style>